export interface NewChartNode {
  id: string;
}

const UNRESOLVED_PARENT = 'UNRESOLVED_PARENT';

export function isUnsavedOrganizationId(id: string): boolean {
  return id.startsWith('temp-') || id.startsWith('import-');
}

/**
 * Nya noder i en ordning där föräldern antingen redan finns
 * eller kommer tidigare i listan.
 */
export function orderNewOrganizationNodes<T extends NewChartNode>(
  nodes: T[],
  parentByChildId: ReadonlyMap<string, string>
): T[] {
  const pending = [...nodes];
  const placed = new Set<string>();
  const ordered: T[] = [];

  while (pending.length > 0) {
    const index = pending.findIndex((node) => {
      const parentId = parentByChildId.get(node.id);
      if (!parentId || !isUnsavedOrganizationId(parentId)) return true;
      return placed.has(parentId);
    });
    if (index < 0) {
      throw new Error(UNRESOLVED_PARENT);
    }
    const [node] = pending.splice(index, 1);
    ordered.push(node);
    placed.add(node.id);
  }

  return ordered;
}

export function isUnresolvedOrganizationParent(error: unknown): boolean {
  return error instanceof Error && error.message === UNRESOLVED_PARENT;
}

export function organizationSaveErrorMessage(error: unknown): string {
  if (typeof error === 'object' && error !== null && 'response' in error) {
    const data = (error as { response?: { data?: { error?: unknown } } }).response?.data;
    if (typeof data?.error === 'string' && data.error.trim()) {
      return data.error.trim();
    }
  }
  if (error instanceof Error && error.message.trim()) {
    return error.message.trim();
  }
  return '';
}
